export default __webpack_public_path__ + "static/media/mirjam.bcac2b30.png";